import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-arrow-clockwise"
}
const _hoisted_2 = { class: "au-card" }
const _hoisted_3 = { class: "au-card-head" }
const _hoisted_4 = { class: "au-card-title" }
const _hoisted_5 = { class: "au-search ms-auto" }
const _hoisted_6 = ["placeholder", "aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "au-empty"
}
const _hoisted_8 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_9 = { class: "visually-hidden" }
const _hoisted_10 = {
  key: 1,
  class: "au-empty"
}
const _hoisted_11 = { class: "au-empty-title" }
const _hoisted_12 = {
  key: 2,
  class: "au-empty"
}
const _hoisted_13 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_14 = { class: "table table-hover" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "au-entity" }
const _hoisted_17 = { class: "au-avatar user-initials" }
const _hoisted_18 = { style: {"min-width":"0"} }
const _hoisted_19 = { class: "au-entity-name" }
const _hoisted_20 = { class: "au-entity-sub" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  class: "spinner-border spinner-border-sm text-primary",
  role: "status"
}
const _hoisted_23 = { class: "visually-hidden" }
const _hoisted_24 = {
  key: 1,
  class: "d-flex flex-wrap gap-2"
}
const _hoisted_25 = {
  key: 2,
  class: "users-muted"
}
const _hoisted_26 = { class: "au-actions" }
const _hoisted_27 = {
  key: 4,
  class: "au-card-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_page_header = _resolveComponent("bs5-page-header")!
  const _component_bs5_badge_with_close = _resolveComponent("bs5-badge-with-close")!
  const _component_bs5_icon_button = _resolveComponent("bs5-icon-button")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!
  const _component_EditUserModal = _resolveComponent("EditUserModal")!
  const _component_SetPasswordModal = _resolveComponent("SetPasswordModal")!
  const _component_AssignDistributorModal = _resolveComponent("AssignDistributorModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_bs5_page_header, {
      title: _ctx.$t('users.title'),
      subtitle: _ctx.$t('users.subtitle')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_bs5_base_button, {
          variant: "secondary",
          loading: _ctx.loading,
          onClick: _ctx.fetchUsers
        }, {
          default: _withCtx(() => [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t("common.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_bs5_base_button, {
          variant: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddUserModal = true))
        }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t("users.new")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-people" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t("users.list")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            class: "form-control",
            placeholder: _ctx.$t('users.search'),
            "aria-label": _ctx.$t('users.search')
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.search]
          ])
        ])
      ]),
      (_ctx.loading && _ctx.users.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("common.loading")), 1)
            ])
          ]))
        : (_ctx.users.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-people" }, null, -1)),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("users.emptyTitle")), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("users.emptyText")), 1)
            ]))
          : (_ctx.filteredUsers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("users.noResults")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-person me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("users.user")), 1)
                      ]),
                      _createElementVNode("th", null, [
                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-shield-check me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("users.role")), 1)
                      ]),
                      _createElementVNode("th", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-shop me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("users.distributors")), 1)
                      ]),
                      _createElementVNode("th", _hoisted_15, [
                        _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-lightning-charge me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("common.actions")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.id as string
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.getInitials(user)), 1),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(user.fullName), 1),
                              _createElementVNode("div", _hoisted_20, [
                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-envelope" }, null, -1)),
                                _createTextVNode(_toDisplayString(user.email), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["au-chip", `is-${_ctx.getRoleStyle(user.role).tone}`])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["bi", _ctx.getRoleStyle(user.role).icon])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.getRoleStyle(user.role).labelKey)), 1)
                          ], 2)
                        ]),
                        _createElementVNode("td", null, [
                          (_ctx.isLoadingDistributors(user))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("common.loading")), 1)
                                ])
                              ]))
                            : (_ctx.getUserDistributors(user).length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUserDistributors(user), (distributor) => {
                                    return (_openBlock(), _createBlock(_component_bs5_badge_with_close, {
                                      key: distributor.id as string,
                                      label: distributor.name,
                                      "close-label": _ctx.$t('users.removeDistributor', { name: distributor.name }),
                                      onRemove: ($event: any) => (_ctx.removeDistributor(user, distributor))
                                    }, null, 8, ["label", "close-label", "onRemove"]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("users.noDistributors")), 1))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_bs5_icon_button, {
                              icon: "bi-pencil",
                              label: _ctx.$t('common.edit'),
                              onClick: ($event: any) => (_ctx.openEditModal(user))
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_bs5_icon_button, {
                              icon: "bi-key",
                              tone: "amber",
                              label: _ctx.$t('users.changePassword'),
                              onClick: ($event: any) => (_ctx.openSetPasswordModal(user))
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_bs5_icon_button, {
                              icon: "bi-diagram-3",
                              tone: "indigo",
                              label: _ctx.$t('users.assignDistributor'),
                              onClick: ($event: any) => (_ctx.openAssignDistributorModal(user))
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_bs5_icon_button, {
                              icon: "bi-trash3",
                              tone: "danger",
                              label: _ctx.$t('common.delete'),
                              loading: _ctx.removeLoading,
                              onClick: ($event: any) => (_ctx.removeUser(user))
                            }, null, 8, ["label", "loading", "onClick"])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])),
      (_ctx.users.length > 0 && _ctx.filteredUsers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("users.total", { count: _ctx.filteredUsers.length })), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AddUserModal, {
      visible: _ctx.showAddUserModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddUserModal = false)),
      onUserAdded: _ctx.fetchUsers
    }, null, 8, ["visible", "onUserAdded"]),
    _createVNode(_component_EditUserModal, {
      visible: _ctx.showEditUserModal,
      userId: _ctx.selectedUserId,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEditUserModal = false)),
      onUserUpdated: _ctx.fetchUsers
    }, null, 8, ["visible", "userId", "onUserUpdated"]),
    _createVNode(_component_SetPasswordModal, {
      visible: _ctx.showSetPasswordModal,
      userId: _ctx.selectedUserId,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSetPasswordModal = false)),
      onPasswordSet: _ctx.fetchUsers
    }, null, 8, ["visible", "userId", "onPasswordSet"]),
    _createVNode(_component_AssignDistributorModal, {
      visible: _ctx.showAssignDistributorModal,
      userId: _ctx.selectedUserId,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAssignDistributorModal = false)),
      onDistributorAssigned: _ctx.fetchUsers
    }, null, 8, ["visible", "userId", "onDistributorAssigned"])
  ]))
}